import { SelectProductForm } from 'components/select-product-form/SelectProductForm';

const AddCompatibleComponent = ({ onAdd }: { onAdd: (newId: string) => void }) => {
    return <SelectProductForm onSelectProduct={onAdd} />;
};

export { AddCompatibleComponent };
